import { defineStore } from 'pinia'
import { $themeConfig } from '@themeConfig'
import { readStoredAccountProfile, sanitizeAccountProfile, writeStoredAccountProfile } from '@/auth/accountProfile'

export const useAppConfigStore = defineStore('AppConfigStore', {
  state: () => {
    const profile = readStoredAccountProfile()
    return {
      layout: {
        isRTL: $themeConfig.layout.isRTL,
        skin: localStorage.getItem('vuexy-skin') || $themeConfig.layout.skin,
        userdata: profile === null ? null : JSON.stringify(profile),
        routerTransition: $themeConfig.layout.routerTransition,
        type: $themeConfig.layout.type,
        contentWidth: $themeConfig.layout.contentWidth,
        menu: {
          hidden: $themeConfig.layout.menu.hidden,
        },
        navbar: {
          type: $themeConfig.layout.navbar.type,
          backgroundColor: $themeConfig.layout.navbar.backgroundColor,
        },
        footer: {
          type: $themeConfig.layout.footer.type,
       },
      },
    }
  },
  getters: {
  },
  actions: {
    toggleRtl() {
      this.layout.isRTL = !this.layout.isRTL
      document.documentElement.setAttribute('dir', this.layout.isRTL ? 'rtl' : 'ltr')
    },
    updateSkin(skin) {
      this.layout.skin = skin

      // Update value in localStorage
      localStorage.setItem('vuexy-skin', skin)

      // Update DOM for dark-layout
      if (skin === 'dark') document.body.classList.add('dark-layout')
      else if (document.body.className.match('dark-layout')) document.body.classList.remove('dark-layout')
    },
    updateUserdata(val) {
      const profile = sanitizeAccountProfile(val)
      const current = readStoredAccountProfile()
      // A late callback cannot restore a signed-out account or replace another account.
      if (profile?.id && (!localStorage.getItem('accessToken') || (current?.id && current.id !== profile.id))) return
      const saved = writeStoredAccountProfile(profile)
      this.layout.userdata = saved === null ? null : JSON.stringify(saved)
      if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('yournutri:photo-session-changed'))
    },
    updateRouterTransition(val) {
      this.layout.routerTransition = val
    },
    updateLayoutType(val) {
      this.layout.type = val
    },
    updateContentWidth(val) {
      this.layout.contentWidth = val
    },
    updateNavMenuHidden(val) {
      this.layout.menu.hidden = val
    },
    updateNavbarConfig(obj) {
      Object.assign(this.layout.navbar, obj)
    },
    updateFooterConfig(obj) {
      Object.assign(this.layout.footer, obj)
    },
  },
})
